import { FC } from 'react';
import { TableHead, TableRow, TableCell, Checkbox } from '@mui/material';
import { TableHeadCell } from '../TableHeadCell';
import { CellRender } from '../../../Cell';

type Props = {
  addClasses: {
    root: string;
    cell: string;
  };
  rowChildrenShow: CellRender<any>[];
  isSort: Partial<Record<string, boolean>> | undefined;
  sortDirection: { sortCol: string; sortDir: number };
  setSortDirection: (
    updateSortDirectionFunction: (setting: {
      sortCol: string;
      sortDir: number;
    }) => {
      sortCol: string;
      sortDir: number;
    }
  ) => void;
  selectButton: any;
  processedDataLength: number;
  changeAll: (event: any) => void;
  selectedLength: number;
};

/**
 * @summary Контейнер для заголовков таблицы.
 *
 * @param rowChildrenShow - Массив ячеек, которые будут отображены.
 * @param addClasses - Дополнительные стили.
 * @param isSort - Key - название столбца, value - можно ли сортировать. Включает возможность сортировки конкретного столбца.
 * @param sortDirection - Текущие настройки сортировки.
 * @param setSortDirection - Сохраняет в localStorage.
 * @param selectButton - Компонент для отображения checkbox.
 * @param processedDataLength - Количество элементов, отображаемых в таблице на текущей странице.
 * @param changeAll - Функция, которая применяется при нажатии на чекбокс в названии колонки.
 * @param selectedLength - Количество выбранных элементов.
 */
export const TableHeadRoot: FC<Props> = ({
  addClasses,
  rowChildrenShow,
  isSort,
  sortDirection,
  setSortDirection,
  selectButton,
  processedDataLength,
  changeAll,
  selectedLength,
}) => (
  <TableHead className={addClasses.root}>
    <TableRow>
      {selectButton && (
        <TableCell className={addClasses.cell} padding="checkbox">
          <Checkbox
            indeterminate={selectedLength > 0 && selectedLength < processedDataLength}
            checked={selectedLength === processedDataLength}
            onChange={changeAll}
          />
        </TableCell>
      )}
      {rowChildrenShow.map((cell) =>
        isSort && isSort[cell.props.columnName] ? (
          <TableHeadCell
            cell={cell}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            key={cell.props.columnName}
            addClass={{ root: addClasses.cell }}
          />
        ) : (
          <TableCell key={cell.props.columnName} className={addClasses.cell}>
            {cell.props.headtitleComponent
              ? cell.props.headtitleComponent({
                  headtitle: cell.props.headtitle,
                })
              : cell.props.headtitle}
          </TableCell>
        )
      )}
    </TableRow>
  </TableHead>
);
